/** Glyphs of the DiorSymboles font, by symbol name. */
export const SYMBOLS: Record<string, string> = {
  eight: '!',
  bee: '#',
  heart: '$',
  star: '%',
  clover: '&',
  montaigne: '*',
  triumph: '@',
  dove: '?',
  eiffel: '>',
  garden: '/',
  rose: '<',
  parrot: '"',
  pampano: '+',
  lily: '=',
  aries: 'µ',
  taurus: '{',
  gemini: '°',
  cancer: '[',
  leo: ']',
  virgo: '²',
  libra: '|',
  scorpius: 'ç',
  sagittarius: 'ù',
  capricornus: 'à',
  aquarius: '§',
  pisces: 'è',
  butterfly: 'é',
};
